import * as api from '../resources/manage-inventory.api';
import actionTypes from './action-types';

export const downloadManageInventoryReportByTabRequest = (tabId) => ({
  type: actionTypes.DOWNLOAD_MANAGE_INVENTORY_REPORT_BY_TYPE_REQUEST,
  tabId,
});

export const downloadManageInventoryReportByTabSuccess = (tabId) => ({
  type: actionTypes.DOWNLOAD_MANAGE_INVENTORY_REPORT_BY_TYPE_SUCCESS,
  tabId,
});

export const downloadManageInventoryReportByTabFailure = (tabId) => ({
  type: actionTypes.DOWNLOAD_MANAGE_INVENTORY_REPORT_BY_TYPE_FAILURE,
  tabId,
});

export const downloadManageInventoryReportByTab = (config) => (dispatch, getState) => {
  try {
    const { session } = getState();
    const retailerIdFromStore = config.filters ? config.filters.retailerId : null;
    const retailerId = retailerIdFromStore || config.retailerId || session.retailer.retailerId;

    const requestParams = {
      ...config,
      retailerId,
    };

    dispatch(downloadManageInventoryReportByTabRequest(config.tabId));

    dispatch(downloadManageInventoryReportByTabSuccess(config.tabId));
    return api.downloadManageInventoryReportByTab(requestParams);
  } catch (error) {
    console.error('DOWNLOAD_MANAGE_INVENTORY_REPORT_BY_TYPE', error);
    dispatch(downloadManageInventoryReportByTabFailure(config.tabId));
  }
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/actions/download-report-by-tab.actions.js